import { Link, useParams } from "react-router-dom";
import Header from "../../../components/layout/Header/Header";
import Footer from "../../../components/layout/Footer/Footer";
import Container from "../../../components/layout/Container/Container";

import { useService } from "../../../api/queries/useService";
import { useServices } from "../../../api/queries/useServices";
import { useGallery } from "../../../api/queries/useGallery";

import s from "./ServicePage.module.scss";

function splitLines(v?: string | null) {
  return (v || "")
    .split(/\r?\n/g)
    .map((x) => x.trim())
    .filter(Boolean);
}

function resolveImageUrl(path?: string) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/")) return path;
  return `/${path}`;
}

export default function ServicePage() {
  const { id } = useParams();
  const serviceId = Number(id);

  const one = useService(serviceId);
  const list = useServices();
  const { data: gallery } = useGallery();

  const data: any = one.data;

  // galleryMap: id → image_path
  const galleryMap = new Map<number, string>();
  (gallery ?? []).forEach((g) => galleryMap.set(g.id, g.image_path));

  // путь к картинке услуги
  const rawPath = data?.image_path_id ? galleryMap.get(data.image_path_id) : "";
  const imgSrc = resolveImageUrl(rawPath);

  const others = (list.data ?? []).filter((x) => x.id !== serviceId).slice(0, 3);

  const how = splitLines(data?.how_treatment);
  const inc = splitLines(data?.includes_in_price);

  return (
    <div className={s.pageWrap}>
      <Header />

      <main className={s.page}>
        <section className="section section--tight">
          <Container>
            <div className={s.stack}>
              {/* ПЛАШКА №1 — основная информация об услуге */}
              <div className={s.panel}>
                <div className={s.breadcrumbs}>
                  <Link to="/">Главная</Link> / <Link to="/services">Услуги</Link> /{" "}
                  <span>{data?.title ?? "Услуга"}</span>
                </div>

                {one.isLoading ? (
                  <div className={s.block}>Загрузка…</div>
                ) : one.isError ? (
                  <div className={s.block}>Ошибка загрузки услуги</div>
                ) : !data ? (
                  <div className={s.block}>Услуга не найдена</div>
                ) : (
                  <>
                    {/* Заголовок + блок стоимости (с картинкой внутри) */}
                    <div className={s.headerRow}>
                      {/* ЛЕВАЯ ЧАСТЬ — текст */}
                      <div className={s.headerText}>
                        <h1 className={s.h1}>{data.title}</h1>
                        <p className={s.lead}>
                          {data.description?.trim()
                            ? data.description
                            : "Описание добавим позже."}
                        </p>
                      </div>

                      {/* ПРАВАЯ ЧАСТЬ — картинка + цена + кнопки */}
                      <aside className={s.side}>
                        <div className={s.contentText}>
                          <div className={s.priceLabel}>Стоимость</div>
                        <div className={s.priceValue}>{data.price}</div>

                        <div className={s.ctaRow}>
                          <Link className={s.ctaPrimary} to="/contacts">
                            Записаться
                          </Link>
                          <Link className={s.ctaGhost} to="/services">
                            Все услуги
                          </Link>
                        </div>
                        </div>
                        <div className={s.contentImage}>
                          <div className={s.sideImageWrap}>
                          {imgSrc ? (
                            <img
                              src={imgSrc}
                              alt={data.title}
                              className={s.sideImage}
                              loading="lazy"
                              onError={(e) => {
                                (e.currentTarget as HTMLImageElement).style.display = "none";
                              }}
                            />
                          ) : (
                            <div className={s.thumbPlaceholder} />
                          )}
                        </div>
                        </div>
                        

                        
                      </aside>
                    </div>

                    {/* Основной контент */}
                    <div className={s.contentGrid}>
                      <section className={s.block}>
                        <h2 className={s.blockTitle}>Рекомендации</h2>

                        {how.length ? (
                          <ul className={s.list}>
                            {how.map((x, i) => (
                              <li key={i} className={s.listItem}>
                                {x}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className={s.text}>
                            Сюда позже добавим понятные шаги процесса (2–5 пунктов).
                          </p>
                        )}
                      </section>

                      <section className={s.block}>
                        <h2 className={s.blockTitle}>Показания</h2>

                        {inc.length ? (
                          <ul className={s.list}>
                            {inc.map((x, i) => (
                              <li key={i} className={s.listItem}>
                                {x}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className={s.text}>
                            Тут позже перечислим: консультация, диагностика, материалы и т.д.
                          </p>
                        )}
                      </section>
                    </div>
                  </>
                )}
              </div>

              {/* ПЛАШКА №2 — другие услуги */}
              <div className={s.panel}>
                <section className={s.otherSection}>
                  <h2 className={s.otherTitle}>Другие услуги</h2>

                  {list.isLoading ? (
                    <div className={s.block}>Загрузка списка услуг…</div>
                  ) : list.isError ? (
                    <div className={s.block}>Не удалось загрузить список услуг</div>
                  ) : (
                    <div className={s.otherGrid}>
                      {others.map((item) => (
                        <article key={item.id} className={s.otherCard}>
                          <h3 className={s.otherCardTitle}>{item.title}</h3>
                          <p className={s.otherCardText}>
                            {item.description?.trim()
                              ? item.description
                              : "Описание добавим позже."}
                          </p>

                          <Link className={s.moreBtn} to={`/services/${item.id}`}>
                            Подробнее
                          </Link>
                        </article>
                      ))}
                    </div>
                  )}
                </section>
              </div>
            </div>
          </Container>
        </section>
      </main>

      <Footer />
    </div>
  );
}
